import i18n from '@/utils/i18n';

const filters =
    [
        {
            name: "category",
            type: "select",
            placeholder: i18n.t('form.type_to_search'),
            label: i18n.t('form.categories'),
            searchable: true,
            multiple: true,
            main: false,
            options: [],
            response_object: "category"
        },
        {
            name: "author",
            type: "select",
            placeholder: i18n.t('form.type_to_search'),
            label: i18n.t('form.authors'),
            searchable: true,
            multiple: true,
            options: [],
            main: false,
            response_object: "author"
        },
        {
            name: "published",
            type: "select",
            label: i18n.t('form.published'),
            searchable: true,
            multiple: false,
            group: false,
            options: [],
            placeholder: i18n.t('form.any'),
            main: false,
            response_object: "published"
        }
    ];

export default filters
